import { useSettings } from "@/lib/useSettings";
import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";
import WhyUs from "@/components/WhyUs";

export default function About() {
  const { settings } = useSettings();
  const s = settings || {};

  return (
    <div data-testid="page-about">
      {/* Hero */}
      <section className="aman-hero relative pt-20 pb-24 md:pt-28 md:pb-32 overflow-hidden">
        <div className="aman-glow-orb -top-32 -end-24" aria-hidden="true" />
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center text-white relative">
          <Reveal>
            <span className="aman-tag mx-auto">من نحن</span>
          </Reveal>
          <Reveal delay={120}>
            <h1 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              نحمي فلسطين، مشروعاً تلو الآخر
            </h1>
          </Reveal>
          <Reveal delay={220}>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed">
              شركة أمان — شريكك الموثوق في الحلول الأمنية منذ 2013.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <Reveal>
            <span className="aman-tag-dark">قصتنا</span>
            <h2 className="font-heading mt-4 text-3xl sm:text-4xl font-bold text-[#0A1628] leading-tight">
              رحلة أكثر من عشر سنوات من الاحترافية
            </h2>
            <p className="mt-6 text-slate-700 text-lg leading-loose">{s.about_story_ar}</p>
          </Reveal>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <div className="max-w-2xl">
              <span className="aman-tag-dark">قيمنا</span>
              <h2 className="font-heading mt-4 text-3xl sm:text-4xl font-bold text-[#0A1628] leading-tight">
                ما يميّزنا عن غيرنا
              </h2>
            </div>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
            {(s.about_values || []).map((v, i) => (
              <Reveal key={v.icon || i} delay={i * 80}>
                <div className="aman-card p-6 h-full">
                  <div className="w-12 h-12 rounded-xl bg-[#0A1628] text-[#00E5FF] flex items-center justify-center">
                    <Icon name={v.icon} size={22} />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-[#0A1628] mt-4">{v.title_ar}</h3>
                  <p className="text-slate-600 text-sm mt-2 leading-relaxed">{v.body_ar}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <WhyUs />
    </div>
  );
}
